import { Component, inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MENU } from '../../app.constants';
import { CommonModule } from '@angular/common';
import { ApiService } from '../../_utils/api/api.service';
import { PwaService } from '../../_utils/pwa/pwa.service';

@Component({
  selector: 'app-bottombar',
  templateUrl: './bottombar.component.html',
  styleUrl: './bottombar.component.scss',
  imports: [CommonModule]
})
export class BottombarComponent implements OnInit {
  private router: Router = inject(Router);
  protected pwaService: PwaService = inject(PwaService);
  private apiService: ApiService = inject(ApiService);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  currentLocation: Subscription | null = null;
  menu: any[] = [];

  constructor() {
    MENU.forEach((menuItem: any) => {
      this.menu.push({
        visible: menuItem.path !== '/info',
        active: false,
        ...menuItem
      });
    });
  }

  ngOnInit(): void {
    // Imposta la route attiva al caricamento iniziale
    this.updateActiveRoute(this.router.url);

    this.apiService.getCompany().subscribe({
      next: (data) => {
        if (data.data.mostra_info) {
          this.menu.map((menuItem: any) => {
            if (menuItem.path === '/info') {
              menuItem.visible = true;
            }
          });
          this.cdr.detectChanges();
        }
      },
      error: (error) => {
        console.error(error);
        this.router.navigate(['error'], { queryParams: { message: error } });
      }
    });

    this.currentLocation = this.router.events.subscribe((val: any) => {
      const url = val.routerEvent?.urlAfterRedirects || val.routerEvent?.url || val.url;
      if (url) {
        this.updateActiveRoute(url);
      }
    });
  }

  private updateActiveRoute(url: string): void {
    this.menu.forEach((menuItem: any) => {
      menuItem.active = false;
      if (menuItem.paths) {
        if (menuItem.paths.includes(url.split('/')[1])) {
          menuItem.active = true;
        }
      } else if (menuItem.path && url === menuItem.path) {
        menuItem.active = true;
      }
    });
  }

  ngOnDestroy(): void {
    this.currentLocation?.unsubscribe();
  }

  goTo(location: string): void {
    this.router.navigate([location]);
  }
}
